import { formatDateForDisplay } from "@/shared/utils";

export function formatTrialPeriodEnd(
  endDate: string | null | undefined,
  t: (key: string, opts?: Record<string, unknown>) => string,
): string {
  if (!endDate) return "—";
  return t("trialPeriod.until", { date: formatDateForDisplay(endDate) });
}
